module.exports = __webpack_public_path__ + "static/media/pro5.5b6fe293.png";